import { render, staticRenderFns } from "./employeeCertificate.vue?vue&type=template&id=4f8364fc"
import script from "./employeeCertificate.vue?vue&type=script&lang=js"
export * from "./employeeCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports